

//styles
import "./styles/app.scss";

import Home from "./pages/home";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { useEffect } from "react";


const firebaseConfig = {
  apiKey: "AIzaSyA8efv7fJiWmHqxSFdr9L8dX7D4ZFR-IGI",
  authDomain: "sagar-naik-ac9ac.firebaseapp.com",
  projectId: "sagar-naik-ac9ac",
  storageBucket: "sagar-naik-ac9ac.appspot.com",
  messagingSenderId: "509888929436",
  appId: "1:509888929436:web:86c5497bb6fb24b9e0d759",
  measurementId: "G-K00FR18QDE"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {

  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    logEvent(analytics, 'website visited');
  }, [])

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
